.field {
  display: grid;
  gap: var(--space-2);
}

.label {
  font: var(--field-label-font, var(--type-compact));
  font-weight: 600;
}

.trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  min-height: var(--input-height, var(--target-min));
  padding: 0 var(--field-padding, var(--space-4));
  border: var(--border-default) solid var(--color-border-default);
  border-radius: var(--radius-control);
  background: var(--color-bg-subtle);
  color: var(--color-content-primary);
  font: var(--field-font, var(--type-body));
  text-align: left;
  cursor: pointer;
}

.trigger[data-hovered] {
  border-color: var(--color-border-strong);
}

.trigger[data-focus-visible] {
  outline: var(--border-strong) solid var(--color-focus-ring);
  outline-offset: 2px;
  box-shadow: 0 0 0 2px var(--focus-ring-inner, var(--color-bg-surface));
}

.trigger[data-disabled] {
  opacity: 0.55;
  cursor: not-allowed;
  border-color: var(--color-border-subtle);
  background: var(--color-bg-surface);
  color: var(--color-content-tertiary);
}

.field[data-disabled] .label {
  color: var(--color-content-tertiary);
}

.popover {
  width: var(--trigger-width);
  border: var(--border-default) solid var(--color-border-strong);
  border-radius: var(--radius-control);
  background: var(--color-bg-surface);
  box-shadow: var(--shadow-modal);
}

.list {
  max-height: 320px;
  padding: var(--space-1);
  overflow: auto;
  outline: none;
}

.item {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  min-height: var(--target-min);
  padding: 0 var(--space-3);
  border-radius: var(--radius-small);
  font: var(--type-compact);
  cursor: pointer;
  outline: none;
}

.item[data-focused] {
  background: var(--color-bg-hover);
}

.item[data-selected] {
  font-weight: 600;
}

.item[data-selected]::after {
  content: '✓';
  margin-left: auto;
}

/* Inline toolbar variant: "Severity  All ▾" in one compact pill-shaped trigger. */
.field[data-inline] {
  display: block;
}

.field[data-inline] .trigger {
  justify-content: flex-start;
  gap: var(--space-2);
  min-height: var(--input-height-compact);
  padding: 0 var(--space-3);
  border-color: var(--color-border-subtle);
  background: var(--color-bg-surface);
  font: var(--type-compact);
  white-space: nowrap;
}

.field[data-inline] .trigger[data-hovered] {
  border-color: var(--color-border-default);
}

.inlineLabel {
  color: var(--color-content-secondary);
}

.field[data-inline] .value {
  font-weight: 600;
}

.field[data-inline] .popover {
  min-width: max(var(--trigger-width), 12rem);
  width: auto;
}
